<template>
  <div v-if="!item.hidden" class="menu-wrapper">
    <template v-if="hasOneShowingChild(item.children,item) && (!onlyOneChild.children||onlyOneChild.noShowingChildren)">
      <app-link v-if="onlyOneChild.meta" :to="resolvePath(onlyOneChild.path)">
        <el-menu-item :index="resolvePath(onlyOneChild.path)" :class="{'submenu-title-noDropdown':!isNest}">
          <i  v-if="item.meta && item.meta.icon"  :class="'iconfont icon-'+item.meta.icon"></i>
          <span v-if="item.meta && item.meta.title" slot="title">{{item.meta.title}}</span>
        </el-menu-item>
      </app-link>
    </template>

    <el-submenu v-else ref="subMenu" :index="resolvePath(item.path)" popper-append-to-body>
      <template slot="title">
        <i v-if="item.meta && item.meta.icon" :class="'iconfont icon-'+item.meta.icon"></i>
        <span v-if="item.meta && item.meta.title" slot="title">{{item.meta.title}}</span>
      </template>
      <sidebar-item
          v-for="child in item.children"
          :key="child.path"
          :is-nest="true"
          :item="child"
          :base-path="resolvePath(child.path)"
          class="nest-menu"
      />
    </el-submenu>
  </div>
</template>

<script>
  import path from 'path'
  import {isExternal} from '@/utils/validate'
  import AppLink from './Link'

  export default {
    name: 'SidebarItem',
    components: {AppLink},
    props: {
      // route object
      item: {
        type: Object,
        required: true
      },
      isNest: {
        type: Boolean,
        default: false
      },
      basePath: {
        type: String,
        default: ''
      }
    },
    data() {
      // To fix https://github.com/PanJiaChen/vue-admin-template/issues/237
      // refactor with render function
      this.onlyOneChild = null
      return {}
    },
    methods: {
      hasOneShowingChild(children = [], parent) {
        const showingChildren = children.filter(item => {
          if (item.hidden) {
            return false
          } else {
            // Temp set(will be used if only has one showing child)
            this.onlyOneChild = item
            return true
          }
        })


        // When there is only one child router, the child router is displayed by default
        if (showingChildren.length === 1 && showingChildren[0].copy) {
          return true
        }

        // Show parent if there are no child router to display
        if (showingChildren.length === 0) {
          this.onlyOneChild = {...parent, path: '', noShowingChildren: true}
          return true
        }

        return false
      },
      resolvePath(routePath) {
        if (isExternal(routePath)) {
          return routePath
        }
        if (isExternal(this.basePath)) {
          return this.basePath
        }
        return path.resolve(this.basePath, routePath)
      }

    }
  }
</script>


<style lang="scss">
  .menu-wrapper {
    .el-menu-item i.iconfont {
      font-size: 15px;
      margin-right: 7px;
    }
    .el-submenu__title i.iconfont {
      font-size: 14px;
      margin-right: 7px;
    }
    .el-submenu__icon-arrow {
      margin-top: -2px;
    }
    a:hover, a:active, a:link {
      color: initial;
      text-decoration: none;
    }
  }
  .el-menu--collapse {
    .el-submenu__title {
      .el-submenu__icon-arrow {
        display: none;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/layout/components/SideBar/SidebarItem.vue